import * as React from 'react'

import SunIconBlack from 'images/ico_sun_black.svg'
import CloudyIconBlack from 'images/ico_cloudy_black.svg'
import RainyIconBlack from 'images/ico_rainy_black.svg'
import { TemperatureUnitContext } from '../../layout/layout'
import { convertToFahrenheit } from '../../../services/convertUnits'

type InfoSectionProps = {
    season?: 'sun' | 'cloudy' | 'rainy',
    amount: number,
    unit?: string,
    bigSize?: boolean,
    className?: string
}
const iconMapping = {
    sun: SunIconBlack,
    cloudy: CloudyIconBlack,
    rainy: RainyIconBlack
}

export const InfoSectionForMap = ({
    amount,
    season,
    unit,
    bigSize,
    className = ''
}: InfoSectionProps) => {

    const [unitFromContext] = React.useContext(TemperatureUnitContext);
    unit = unitFromContext || unit;
    season = season || 'sun';
    let imageSrc = iconMapping[season];
    if (unit == 'F') {
        amount = convertToFahrenheit(amount);
    }
    amount = Math.round(amount);

    let units = <span>{`°${unit}`}</span>;

    return (
        <div className={className}>
            <div className={`flex justify-center whitespace-nowrap items-center`}>

                <img src={imageSrc} alt="" className={`${bigSize ? 'w-[20px] h-[20px]' : 'w-[16px] h-[16px]'}`} />
                <span className={`${bigSize ? 'text-[16px]' : 'text-[12px]'} font-bold ml-[8px]`}>{amount} {units}</span>
            </div>
        </div>
    )
}